<template>
  <div>
    <v-card-text v-if="totalPages">
      <div>
      <v-simple-table>
      <template v-slot:default>

       <tr>
         <th class="blue lighten-5">Post</th>
         <th class="blue lighten-5">Sha1
           <a v-if="classifierLinksPerm" href="#" v-on:click.prevent="openAllImages" title="Open all Media in Classifier">
              <img height="24" width="24" src="/static/images/logos/arachnid-spider-en.svg">
           </a>

         </th>
         <th class="blue lighten-5">Classification</th>
         <th class="blue lighten-5">Series</th>
       </tr>

       <template v-for="item in displayedItem">
         <tr v-for="(media, media_index) in item.media" :key="media.sha1">
           <td v-if="media_index === 0" :rowspan="item.media.length" style="vertical-align: middle" class="shortener">
             <a :href="'/en/message-search/?query='+ item.doc_id" :title="item.post_details">
               <span v-html="makeSourcesCopyable(item.post_details)"></span>
             </a>
           </td>
           <td class="column"><a :href="mediaSearchLink(media.sha1)"> {{ media.sha1 }}</a>
              <a v-if="classifierLinksPerm"
                 :href="classifierLink + media.sha1"
                 title="Open Media in Classifier"
                 target="_blank"
              >
                <img height="24" width="24" src="/static/images/logos/arachnid-spider-en.svg">
              </a>
           </td>
           <td>{{ media.classification }}</td>
           <td>
             <template v-if="media.series.length > 0">
               {{ media.series.join(", ") }}
             </template>
             <template v-else>
               No Series
             </template>
           </td>

         </tr>
       </template>

      </template>
      </v-simple-table>


      <message-search-page-nav
          :initCurrentPage="currentPage"
          :totalPages="totalPages"
          @page-nav="handlePageNav"
          @select-page="updateCurrentPage"
      />
      </div>
    </v-card-text>
  </div>
</template>

<script>

import UserDetailMedia from "./UserDetailMedia.vue";
import MessageSearchPageNav from "../message_search/MessageSearchPageNav.vue";
import {makeSourcesCopyable} from "../utils.js"


export default {
  name: 'PostWithMedia',
  components: {MessageSearchPageNav, UserDetailMedia},
  props: {
    mediaSearchUrl: {
      type: String,
      required: false,
    },
    totalMediaPost: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      perPageMax: 100,
      perPageMin: 1,
      currentItem: '',
      currentPage: 1,
      itemsPerPage: 10,
      // show classifier links?
      classifierLinksPerm: false,
      classifierLink: 'https://classifier.arachnid.ad.protectchildren.ca/vue/grid/#/?sha1=',
    }
  },
  mounted() {
      this.classifierLinksPerm = window.classifier_links_perm
  },
  computed: {
    displayedItem() {
      const startIdx = (this.currentPage - 1) * this.itemsPerPage
      const endIdx = startIdx + this.itemsPerPage
      return this.totalMediaPost.slice(startIdx, endIdx)
    },
    totalPages() {
      return Math.ceil(this.totalMediaPost.length / this.itemsPerPage)
    },
  },
  methods: {
    makeSourcesCopyable,
    handlePageNav(data) {
      if (data === 'prev') this.prevPage()
      if (data === 'next') this.nextPage()
    },
    updateCurrentPage(page) {
      this.$store.commit('start', (this.limit * parseInt(page)) - 1)
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++
      }
    },

    mediaSearchLink(imgHash) {
      return `${this.mediaSearchUrl}?sha1=${imgHash}`
    },
    openAllImages() {
      let sha1s = []
      this.displayedItem.forEach((post) => {
        post.media.forEach((item) => {
          sha1s.push(item.sha1)
        })
      })

      // this should probably be hardcoded somewhere?
      let classifierLink = this.classifierLink + sha1s.join(',')
      window.open(classifierLink, '_blank')
    },
  }

}
</script>

<style scoped>
.display-items > div {
  display: flex;
  height: 55px;
  line-height: 55px;
}

.display-items-header {
  font-weight: bold;
  border-bottom: 2px solid rgb(230, 229, 229);
}

.display-item {
  border-bottom: 2px solid rgb(230, 229, 229);
}

.display-item button {
  transform: scale(0.8);
}

.display-items-header > div,
.display-item > div {
  width: 300px;
  flex-grow: 1;
}

.display-items-header > div:first-child,
.display-item > div:first-child {
  width: 500px;
}

.display-items-header > div:last-child,
.display-items-header > div:nth-last-child(2),
.display-item > div:last-child,
.display-item > div:nth-last-child(2) {
  width: 400px;
  max-width: 400px;
}

div.shortener {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

td.column {
  white-space: nowrap;
}

</style>
